import React from 'react';
import PublishingMetadataField from './Field/component';

export function WhatIsHappeningField() {
  return (
    <PublishingMetadataField
      label="What's Happening?"
      fieldName="whatIsHappening"
      multiline
      rows={3}
      withEmojis
    />
  );
}
